<template lang="pug">
UiModal(
  :show="show"
  @close="close"
  :title="$t('companies.account_keyword.create_title')"
  :rightActions="rightActions"
  width="620"
)
  UiFormGroup(
    :label="$t('companies.account_keyword.number')"
    :vuelidateModel="v$.form.number"
  )
    UiInput(
      v-model="form.number"
      :error="v$.form.number.$error"
      type="number"
    )
  UiFormGroup(:label="$t('companies.account_keyword.keywords')")
    UiTagsInput(
      v-model="form.keywords"
      :minChars="1"
      :placeholder="$t('companies.dimensions.keywords_prompt')"
    )
</template>

<script>
import ApiCompanyAccountKeyword from "@/api/companyAccountKeyword.js";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  validations() {
    return {
      form: {
        number: {
          required,
        },
      },
    };
  },

  data() {
    return {
      show: false,
      companyId: null,
      form: {
        number: "",
        keywords: [],
      },
    };
  },

  computed: {
    rightActions() {
      return [
        {
          label: this.$t("actions.save"),
          icon: "Check",
          onClick: this.save,
        },
      ];
    },
  },

  methods: {
    open(companyId) {
      this.companyId = companyId;
      this.show = true;
      this.form = {
        number: "",
        keywords: [],
      };
    },

    close() {
      this.show = false;
    },

    save() {
      this.v$.$validate().then((res) => {
        if (!res) {
          return;
        }
        ApiCompanyAccountKeyword.createAccountKeyword(this.companyId, {
          ...this.form,
          keywords: this.form.keywords,
        })
          .then((res) => {
            this.$emit("done");
            this.close();
          })
          .catch((e) => {});
      });
    },
  },
};
</script>
